import { makeStyles, Theme } from '@material-ui/core';
import { Themes } from 'modules/themes/types';

export const useLogoStyles = makeStyles<Theme>(theme => ({
  root: {
    textDecoration: 'none',
    color:'#fff',
    fontSize:'22px',
    fontWeight:800,
    display:'flex',
    alignItems:'center',
    fontFamily:'"Roboto Condensed"',
    '&:hover': {
      color: '#fff',
    },
  },

  img: {
    display: 'block',
    height: 52,
  },
  [theme.palette.type === Themes.light ? 'ableLight' : 'ableDark']: {
    display: 'none',
  },
}));
